import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { PromiseSection } from './components/Promise';
import { Method } from './components/Method';
import { Package } from './components/Package';
import { Testimonials } from './components/Testimonials';
import { ForWho } from './components/ForWho';
import { Results } from './components/Results';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen font-sans text-gray-800 selection:bg-olive-green selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <Method data-id="element-4" />
      <Package data-id="element-5" />
      <Testimonials data-id="element-6" />
      <ForWho data-id="element-7" />
      <Results data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FinalCTA data-id="element-10" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Sabores que Adelgazan. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}